module.exports = __webpack_public_path__ + "static/media/URY.096849e3.svg";